import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Constants } from './shared/constants';
import { TicketLinkComponent } from './features/ticket-link/ticket-link.component';
import { TicketAssignmentComponent } from './features/ticket-assignment/ticket-assignment.component';
import { ConfirmationComponent } from './features/confirmation/confirmation.component';
import { AuthGuardService } from './shared/guards/auth-guard.service';
import { TicketAssignmentGuardService } from './features/ticket-assignment/guards/ticket-assignment-guard.service';

const routes: Routes = [
  {
    path: Constants.ROUTE_LINKS,
    canActivate: [ AuthGuardService ],
    component: TicketLinkComponent
  },
  {
    path: Constants.ROUTE_ASSIGN,
    canActivate: [ AuthGuardService, TicketAssignmentGuardService ],
    component: TicketAssignmentComponent
  },
  {
    path: Constants.ROUTE_CONFIRM,
    canActivate: [ AuthGuardService ],
    component: ConfirmationComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
